<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Promotion Send
    div#promotion-pie
</template>

<script>
import dashbaordService from '../../service.js'
export default {
  props: {
    activeStore: {
      default: 0
    },
  },
  watch: {
    activeStore(val) {
      this.fixPromotion()
    },
  },
  methods: {
    fixPromotion() {
      return dashbaordService.getPromotionCount()
      .then(data => {
        if(data) {
          var newData = []

          newData.push({
            name:'Sending',
            y: data.data
          })

          newData.push({
            name:'Not Sending',
            y: this.activeStore - data.data,
            sliced: true,
            selected: true
          })

          var HighChartPie = $('#promotion-pie')
          if (HighChartPie.length) {
              HighChartPie.highcharts({
                credits: false,
                colors: ['#76BF79', '#1D8BF1', '#3bafda'],
                chart: {
                  plotBackgroundColor: null,
                  plotBorderWidth: 0,
                  plotShadow: false
                },
                title: {
                  text: null
                },
                tooltip: {
                  pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                  pie: {
                    dataLabels: {
                      enabled: true,
                      distance: -50,
                      style: {
                        fontWeight: 'bold',
                        color: 'white'
                      }
                    },
                    startAngle: -90,
                    endAngle: 90,
                    center: ['50%', '75%'],
                    size: '110%'
                  }
                },
                series: [{
                  type: 'pie',
                  name: 'Browser share',
                  innerSize: '50%',
                  data: newData
                }]
              })
          }
        }
      })
    }
  }
}
</script>
